import { useEffect, useState } from "react";
import useMeasure from "react-use/lib/useMeasure";
import { Box3, Group, Vector3 } from "three";
import { calculateCameraPosition, getCameraTarget } from "utils/camera";

export interface UseCameraPositionProps {
  scene: Group;
  fillPercentage: number;
  initialCameraPosition?: [number, number, number];
  initialTarget?: [number, number, number];
}

export const useCameraPosition = ({ scene, fillPercentage, initialCameraPosition }: UseCameraPositionProps) => {
  const [cameraPosition, setCameraPosition] = useState(new Vector3(0, 0, 0));
  const [cameraTarget, setCameraTarget] = useState(new Vector3(0, 0, 0));
  const [containerRef, { width, height }] = useMeasure();
  const [wasSet, setWasSet] = useState(false);

  useEffect(() => {
    if (width && height && scene && !wasSet) {
      const boundingBox = new Box3().setFromObject(scene);
      setCameraPosition(
        initialCameraPosition
          ? new Vector3(...initialCameraPosition)
          : calculateCameraPosition(boundingBox.min, boundingBox.max, fillPercentage)
      );
      setCameraTarget(getCameraTarget(boundingBox.min, boundingBox.max));
      setWasSet(true);
    }
  }, [scene, width, height, initialCameraPosition, wasSet]);

  return { containerRef, cameraPosition, cameraTarget };
};
